{
  "title": "Название",
  "tab": "Вкладка",
  "empty": "Выберите вкладку или создайте новую",
  "dashboardChanged": "В дашборд были внесены изменения",
  "variables": {
    "title": "Переменные вкладки",
    "edit": "Настроить переменные",
    "name": "Имя переменной",
    "type": "Тип переменной",
    "typeSelect": "Список вариантов",
    "typeText": "Строка",
    "multi": "Несколько значений",
    "options": "Варианты",
    "noOptions": "Пока нет вариантов. Добавьте первое значение.",
    "value": "Значение",
    "label": "Подпись (необязательно)",
    "select": "Выберите значение",
    "enterValue": "Введите значение",
    "invalid": "Проверьте имена переменных и значения вариантов",
    "duplicate": "Имена переменных и значения вариантов должны быть уникальными",
    "new": "Новая переменная",
    "selectVariable": "Выберите переменную или добавьте новую",
    "removeVariable": "Удалить переменную"
  },
  "addTabDialog": {
    "title": "Добавить вкладку",
    "selectDashboard": "Выбрать дашборд",
    "dashboard": "Дашборд",
    "name": "Имя",
    "tab": "Вкладка",
    "restoreFromHistory": "Восстановить из истории",
    "newTab": "Новая вкладка"
  },
  "menu": {
    "options": {
      "readonly": {
        "title": "Редактирование дашборда",
        "toggle": "Разрешить редактирование"
      },
      "filter": {
        "title": "Фильтр",
        "apply": "Применить",
        "clear": "Очистить",
        "add": "Добавить"
      },
      "save": {
        "title": "Сохранить",
        "saveDashboard": "Сохранить дашборд"
      },
      "reload": "Обновить данные",
      "reset": {
        "title": "Синхронизировать",
        "tooltip": "Загрузить актуальный дашборд с сервера"
      },
      "add": "Добавить виджет",
      "share": "Поделиться",
      "viewSRM": "Просмотреть СРМ",
      "fullscreen": "Полноэкранный режим"
    },
    "widgets": {
      "thresholdsWidget": {
        "type": {
          "label": "Тип",
          "range": "Числовой диапазон",
          "string": "Строка",
          "pivotTable": "Сводная таблица"
        },
        "value": {
          "label": "Значение",
          "placeholder": "Введите значение"
        },
        "color": "Цвет",
        "message": {
          "label": "Сообщение",
          "placeholder": "Введите сообщение"
        }
      }
    }
  },
  "error": {
    "dashboardError": "Ошибка дашборда"
  },
  "notifications": {
    "updated": "Дашборд обновлен",
    "tqlChanged": "ТQL был изменен"
  },
  "redirect": {
    "save": "Сохранить",
    "continue": "Продолжить без сохранения",
    "changed": "Вкладка изменена. Обновить текущий дашборд?"
  },
  "widgets": {
    "cards": {
      "timeRangeDisabled": "Данные не ограничены диапазоном дашборда",
      "updatesPaused": {
        "label": "Приостановлено",
        "title": "Обновление остановлено"
      },
      "updatesLive": {
        "label": "Активно",
        "title": "Обновления в реальном времени"
      },
      "action": {
        "enable": "Приостановить",
        "disable": "Возобновить обновление"
      }
    },
    "menu": {
      "edit": "Редактировать",
      "delete": "Удалить",
      "clone": "Клонировать",
      "restore": "Восстановить",
      "openDashboard": "Открыть дашборд",
      "pip": "Картинка в картинке",
      "window": "Окно",
      "fullscreen": "Во весь экран"
    },
    "floating": {
      "close": "Закрыть"
    },
    "editMenu": {
      "return": "Назад",
      "apply": "Применить",
      "delete": "Удалить",
      "save": "Сохранить",
      "preview": "Предпросмотр",
      "selectWidget": "Выберите виджет",
      "widgetTags": {
        "placeholder": "Макет",
        "deprecated": "Устарел",
        "beta": "Beta"
      },
      "version": {
        "outdated": "Конфигурация виджета устарела",
        "outdatedToDo": "Обновите виджет, сохранив его"
      }
    },
    "legend": {
      "default": {
        "title": "Легенда"
      }
    },
    "newWidget": {
      "title": "Новый виджет",
      "new": "Новый",
      "existing": "Существующий",
      "selectWidget": "Выбрать виджет"
    },
    "missingWidget": "Виджет не найден",
    "settings": {
      "title": "Название",
      "widgetTitle": "Заголовок виджета",
      "hideTitle": "Скрыть заголовок",
      "unit": "Единица измерения",
      "settingsTitle": "Настройки",
      "dataLinks": {
        "title": "Ссылки на данные",
        "linkTitle": "Название ссылки",
        "dashboard": "Дашборд",
        "includeCurrentVariables": "Передавать переменные текущей вкладки",
        "variable": "Переменная целевого дашборда",
        "source": "Источник значения",
        "sources": {
          "cell": "Текущая ячейка",
          "field": "Поле строки",
          "index": "Индекс данных",
          "variable": "Переменная вкладки",
          "literal": "Фиксированное значение"
        },
        "sourceInputs": {
          "field": "Путь к полю",
          "variable": "Имя переменной",
          "literal": "Значение"
        },
        "addLink": "Добавить ссылку",
        "addMapping": "Добавить сопоставление переменной"
      },
      "linkedDashboard": {
        "title": "Привязка дашборда",
        "dashboard": "Дашборд",
        "nodeId": "Узел TQL",
        "defaultDashboard": "Дашборд по умолчанию",
        "addGroup": "Добавить группу",
        "group": "Группа",
        "sourceNode": "Узел TQL",
        "targetNode": "Узел TQL дашборда",
        "hideDashboardButton": "Скрыть кнопку открытия дашборда"
      },
      "filter": {
        "title": "Фильтр",
        "addButton": "Добавить",
        "nodeId": "Узел TQL",
        "cis": "КЕ"
      },
      "noDataPlaceholder": {
        "title": "Отображение отсутствующих данных",
        "enabled": "Включено",
        "message": "Текст",
        "icon": {
          "title": "Иконка",
          "noData": "Нет данных",
          "info": "Информация",
          "warning": "Предупреждение",
          "error": "Ошибка",
          "success": "Успешно"
        },
        "color": "Цвет"
      },
      "legend": {
        "title": "Легенда",
        "position": {
          "title": "Позиция",
          "left": "Лево",
          "right": "Право",
          "top": "Верх",
          "bottom": "Низ"
        },
        "defaultSize": "Размер по умолчанию (%)",
        "hide": "Скрыть"
      },
      "curveType": {
        "title": "Тип линии",
        "linear": "Линейная",
        "cardinal": "Сглаженная",
        "step": "Шаговая",
        "stepBefore": "Шаговая до",
        "stepAfter": "Шаговая после"
      },
      "stackOffset": {
        "title": "Смещение стека",
        "none": "Нет",
        "expand": "Нормализация (Стек нормализуется до 100%)",
        "diverging": "Сложение (Значения складываются друг на друга)",
        "wiggle": "Покачивание (Минимизирует изменение наклона)",
        "silhouette": "Расходящийся (Стеки центрируются относительно нуля)"
      },
      "bar": {
        "mode": {
          "title": "Режим столбиков",
          "single": "Одиночный",
          "stacked": "С накоплением",
          "stacked100": "С накоплением до 100%",
          "grouped": "Сгруппированный"
        },
        "maxBars": "Максимум столбиков (для метрик)",
        "minBarWidth": "Минимальная ширина столбика (px)",
        "maxBarWidth": "Максимальная толщина столбика (px)",
        "valueLabels": "Показывать значения",
        "thresholdFill": {
          "title": "Заливка по порогу",
          "whole": "Весь столбик",
          "overflow": "Часть выше порога"
        },
        "orientation": {
          "title": "Ориентация",
          "vertical": "Вертикальная",
          "horizontal": "Горизонтальная"
        },
        "sort": {
          "title": "Сортировка",
          "by": "Сортировать по",
          "value": "Значению",
          "name": "Имени"
        }
      },
      "series": {
        "thresholdFill": {
          "title": "Заливка по порогу",
          "line": "Только линия",
          "above": "Область выше порога"
        }
      },
      "textStyle": {
        "title": "Стиль текста",
        "fontSize": "Размер шрифта",
        "color": "Цвет",
        "fill": "Заливка"
      },
      "lineStyle": {
        "title": "Стиль линии",
        "color": "Цвет",
        "width": "Ширина",
        "radius": "Радиус",
        "dash": {
          "title": "Пунктир",
          "firstTitle": "Ширина",
          "secondTitle": "Интервал"
        }
      },
      "annotations": {
        "title": "Аннотации",
        "type": "Типа",
        "regionFilter": {
          "start": "Начало",
          "end": "Конец",
          "color": "Цвет"
        },
        "text": {
          "position": "Позиция",
          "offsetY": "Сдвиг по оси Y",
          "content": "Текст"
        },
        "line": {
          "start": "Начало",
          "end": "Конец"
        }
      },
      "dataSource": {
        "dataType": "Тип источника данных",
        "queryType": "Тип запроса",
        "title": "Источник данных",
        "cisGrouped": "Группировка КЕ",
        "dataTransform": {
          "title": "Преобразование данных",
          "data": "Данные",
          "transform": "Преобразование",
          "result": "Результат",
          "noData": "Выполните тестовый запрос"
        },
        "grouping": {
          "title": "Группировка",
          "type": "Тип группировки",
          "showTQLNodes": "Показывать узлы TQL",
          "ci": "КЕ",
          "tqlNodes": "Узлы TQL",
          "fallback": "Вся область видимости TQL"
        },
        "missingDatasource": "Отсутствует настройка источника данных",
        "useLastValue": "Использовать последнее значение",
        "tableName": "Название таблицы"
      },
      "treeSettings": {
        "title": "Выбор узлов TQL",
        "treeTitle": "Настройка иерархии узлов TQL"
      },
      "dashboardMapper": {
        "title": "Привязка дашбордов",
        "addGroup": "Добавить группу",
        "tqlNode": "Узел TQL",
        "group": "Группа",
        "groupCI": "Группа КЕ",
        "dashboard": "Дашборд КЕ",
        "dashboardTqlNode": "Узел TQL дашборда КЕ",
        "groupDashboard": "Дашборд группы",
        "groupDashboardTqlNode": "Узел TQL дашборда группы"
      },
      "attributeValue": {
        "attribute": "Атрибут",
        "addGroup": "Добавить группу",
        "tqlNode": "Узел TQL"
      },
      "metricEditor": {
        "title": "Метрики",
        "aliasEditor": "Переименование",
        "addGroup": "Добавить группу",
        "add": "Добавить",
        "tqlNode": "Узел TQL",
        "group": "Группа",
        "queries": "Запросы",
        "alias": {
          "type": {
            "title": "Тип",
            "static": "Константа",
            "dynamic": "Динамический"
          },
          "functions": {
            "enumMap": "Привязка возможных значений",
            "kvMap": "Ключ-значение",
            "kvRegexMap": "Ключ-значение регулярное выражение"
          },
          "labels": {
            "title": "Лейблы",
            "__name__": "Имя метрики",
            "ci_id": "Идентификатор CI",
            "ci_name": "Имя CI",
            "ci_type_id": "Идентификатор типа CI",
            "ci_type_name": "Тип CI"
          },
          "name": "Название",
          "mapper": {
            "title": "Привязка лейблов",
            "source": "Лейбл",
            "target": "Замена"
          },
          "metrics": {
            "title": "Привязка метрик",
            "source": "Метрика",
            "target": "Замена"
          }
        }
      },
      "opensearchEditor": {
        "title": "Opensearch",
        "addGroup": "Добавить группу",
        "add": "Добавить",
        "tqlNode": "Узел TQL",
        "group": "Группа",
        "queries": "Запросы",
        "index": "Индекс",
        "timeField": "Поле времени",
        "timeFieldDisabledHint": "Диапазон дашборда не применяется",
        "query": "DSL запрос"
      },
      "tableDefaultSort": {
        "title": "Сортировка таблицы по умолчанию",
        "column": "Столбец",
        "target": "Сортировка",
        "asc": "По возрастанию",
        "desc": "По убыванию"
      }
    },
    "charts": {
      "areaChart": {
        "name": "Диаграмма областей",
        "settings": {
          "isPercent": "В процентах"
        }
      },
      "timeSeriesBarChart": {
        "name": "Столбчатая диаграмма по времени"
      },
      "categoryBarChart": {
        "name": "Столбчатая диаграмма по категориям",
        "uncategorized": "Без категории"
      },
      "sankey": {
        "name": "Санкей",
        "settings": {
          "nodeAlign": {
            "title": "Выравнивание узлов",
            "center": "По центру",
            "justify": "По ширине",
            "left": "По левому краю",
            "right": "По правому краю"
          },
          "nodeWidth": "Ширина узла (px)",
          "nodePadding": "Отступ между узлами (px)",
          "nodeLabels": "Подписи узлов",
          "nodeLabelPlacement": {
            "title": "Положение подписей узлов",
            "beside": "Рядом с узлом",
            "inside": "Внутри узла"
          },
          "nodeValues": "Значения узлов",
          "linkValues": "Значения связей",
          "valueDisplay": {
            "title": "Режим отображения значений",
            "value": "Значение",
            "percent": "Процент",
            "valuePercent": "Значение и процент"
          }
        }
      },
      "chord": {
        "name": "Хорда",
        "settings": {
          "ringWidth": "Толщина кольца (px)",
          "padAngle": "Зазор между дугами (°)",
          "nodeLabels": "Подписи узлов",
          "nodeValues": "Значения узлов",
          "linkValues": "Значения связей",
          "valueDisplay": {
            "title": "Режим отображения значений",
            "value": "Значение",
            "percent": "Процент",
            "valuePercent": "Значение и процент"
          }
        }
      },
      "heatMap": {
        "name": "Тепловая карта",
        "settings": {
          "maxCells": "Максимум интервалов (для метрик)",
          "minCellWidth": "Минимальная ширина ячейки (px)",
          "minCellHeight": "Минимальная высота ячейки (px)",
          "colorMode": {
            "title": "Цветовая шкала",
            "gradient": "Градиент",
            "thresholds": "Пороги"
          },
          "gradientLow": "Цвет минимума",
          "gradientHigh": "Цвет максимума",
          "gradientStops": {
            "title": "Промежуточные точки градиента",
            "point": "Точка градиента",
            "position": "Позиция на шкале (%)",
            "color": "Цвет"
          },
          "scaleMode": {
            "title": "Границы градиента",
            "auto": "Автоматически",
            "manual": "Вручную"
          },
          "scaleMin": "Минимум шкалы",
          "scaleMax": "Максимум шкалы"
        },
        "invalidScale": "Минимум шкалы должен быть меньше максимума; обе границы должны быть числами.",
        "invalidGradient": "Позиции точек градиента должны быть уникальными числами между 0 и 100%, цвета — в формате HEX.",
        "allValues": "Все значения"
      },
      "map": {
        "name": "Карта",
        "cisWithoutCoordinates": "КЕ без координат"
      },
      "gaugeChart": {
        "name": "Измерение"
      },
      "graph": {
        "name": "Граф",
        "settings": {
          "defaultGraphSchema": {
            "title": "Отображение графа"
          },
          "nestedMode": {
            "title": "Отображение дашборда",
            "modal": "Модальное окно",
            "drawer": "Боковая панель",
            "size": "Размер",
            "type": "Тип"
          },
          "grid": "Сетка"
        }
      },
      "text": {
        "name": "Текст",
        "textTooLongToBeDisplayed": "Текст слишком длинный для отображения",
        "settings": {
          "valueDisplayMode": {
            "label": "Режим отображения значений",
            "text": "Текст",
            "codeEditor": "Редактор кода"
          }
        }
      },
      "pieChart": {
        "name": "Круговая диаграмма",
        "settings": {
          "radius": "Радиус",
          "label": {
            "label": "Метка",
            "position": {
              "label": "Позиция",
              "inner": "Внутрь",
              "outer": "Снаружи",
              "spider": "\"Паук\""
            },
            "content": "Формат содержания",
            "offset": "Смещение"
          },
          "annotations": "Аннотации",
          "valueDisplay": {
            "title": "Режим отображения значений",
            "value": "Значение",
            "percent": "Процент",
            "valuePercent": "Процент и значение"
          }
        }
      },
      "liquidChart": {
        "name": "Шкала"
      },
      "lineChart": {
        "name": "Линейный график",
        "settings": {
          "xAxis": "Ось X",
          "yAxis": {
            "label": "Ось Y",
            "min": "Минимум",
            "max": "Максимум",
            "logScale": "Логарифмическая шкала"
          },
          "isStacked": "Сложенный",
          "stepType": {
            "title": "Тип шага",
            "empty": "По умолчанию"
          },
          "point": {
            "title": "Точка",
            "size": "Размер",
            "color": "Цвет",
            "shape": {
              "title": "Форма",
              "square": "Квадрат",
              "circle": "Круг",
              "diamond": "Алмаз"
            }
          },
          "smooth": "Сглаживание"
        }
      },
      "opensearchTable": {
        "name": "Таблица Opensearch"
      },
      "hiValue": {
        "name": "Индикаторы здоровья",
        "ciName": "Имя КЕ",
        "indicators": "Индикаторы",
        "change_status": "Изменение статуса",
        "summary": "Сводка",
        "events": "События",
        "description": "Описание",
        "duration": "Длительность",
        "startDate": "Время начала",
        "settings": {
          "viewMode": {
            "label": "Режим отображения",
            "cells": "Ячейки",
            "table": "Таблица"
          }
        }
      },
      "calculatedHI": {
        "name": "Расчетный индикатор здоровья",
        "legend": "Статусы",
        "startedAtPrefix": "с",
        "settings": {
          "nodes": "Узлы TQL",
          "hiType": "Индикатор здоровья",
          "hiTypesUnavailable": "Список доступных ИЗ временно недоступен",
          "clickAction": {
            "title": "Действие при клике",
            "hi": "Индикатор здоровья",
            "dashboard": "Дашборд"
          },
          "normalizeBarChart": "Нормализовать столбчатую диаграмму"
        }
      },
      "divider": {
        "name": "Разделитель"
      },
      "timeline": {
        "name": "История индикаторов здоровья",
        "tooltip": {
          "start": "Начало",
          "end": "Конец",
          "ongoing": "В процессе"
        }
      },
      "singleValue": {
        "name": "Одно значение",
        "dataSource": {
          "metrics": "Метрики",
          "attributeValue": "Значения атрибутов",
          "staticValue": {
            "label": "Статическое значение",
            "value": "Значение"
          },
          "opensearch": "Opensearch",
          "unableToRender": "Данные не могут быть отображены"
        },
        "settings": {
          "valueMapper": "Привязка единиц измерения",
          "valueMapping": {
            "label": "Привязка значений",
            "source": "Точное значение",
            "target": "Измененное значение"
          },
          "autoSize": "Авторазмер",
          "valuesRenderMode": {
            "title": "Режим отображения значений",
            "panels": "Панели",
            "tabs": "Вкладки"
          },
          "transparentBackground": "Прозрачный фон",
          "thresholds": {
            "title": "Пороговые значения",
            "to": "До",
            "from": "От",
            "message": "Текст"
          }
        }
      },
      "nestedDashboard": {
        "name": "Вложенный дашборд",
        "empty": "Выберите дашборд",
        "error": "Ошибка дашборда",
        "resetLayout": "Сброс расположения",
        "search": "Поиск",
        "expand": "Развернуть",
        "collapse": "Свернуть",
        "noDashboard": "Отсутствует привязка дашборда",
        "missingNode": "Узел отсуствует в TQL",
        "ci": "КЕ",
        "enrichment": "Обогащение",
        "nestedLayoutsWarning": "Используется переопределенное расположение"
      },
      "hiTable": {
        "name": "Таблица истории индикаторов здоровья",
        "ci_name": "Имя КЕ",
        "severity": "Статус",
        "summary": "Тревога",
        "starts_at": "Начало",
        "ends_at": "Конец",
        "dataSource": {
          "showActiveOnly": "Только активные ИЗ"
        },
        "settings": {
          "datetimeFormat": "Формат даты и времени",
          "columns": "Колонки",
          "hiStatusSelector": "Значение фильтра состояния по умолчанию"
        }
      },
      "ciTypesTable": {
        "name": "Таблица КЕ"
      },
      "pivotTable": {
        "name": "Сводная таблица",
        "rows": "Строки",
        "columns": "Столбцы",
        "aliasMapper": {
          "title": "Переименование столбцов/строк",
          "source": "Оригинальное значение"
        },
        "AggrFunction": "Функция аггрегации",
        "hideColumns": "Скрыть несуществующие колонки",
        "thresholdsMapper": "Привязка пороговых значений",
        "expandDepth": "Глубина раскрытия подстрок"
      }
    }
  }
}
